module.exports = __webpack_public_path__ + "static/media/Dashboard.c260dc46.svg";